import { CURRENCIES } from '../data/constants';

export default function CurrencySelect({ value, onChange, className, style = {} }) {
  return (
    <select
      value={value || 'JPY'}
      onChange={e => onChange(e.target.value)}
      className={className || 'form-select'}
      style={{ width: 75, fontSize: 12, padding: '4px 6px', ...style }}
    >
      {Object.keys(CURRENCIES).map(code => (
        <option key={code} value={code}>{code}</option>
      ))}
    </select>
  );
}
